module.exports = __webpack_public_path__ + "img/horizontal_6_4_8004.e7b73080.png";